import { useInstance } from '@meraki-internal/react-dependency-injection';
import { FC } from 'react';
import { IntercomService, IntercomState } from '../IntercomService';
import { useSubscription } from '@meraki-internal/state';
import { ReminderBadge } from '../../components/ReminderBadge';
import { NavigationItem } from '../../navigation/NavigationItem';
import { DuoCommentsIcon } from '../../theme/Icons';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
    chatNavItem: {
        '& > div > ion-item > div > ion-text': {
            marginLeft: 0,
            fontSize: '25px !important'
        }
    }
});

interface IIntercomNavItemProps {
    clickHandler: (execute: () => void) => void;
};

export const IntercomNavItem: FC<IIntercomNavItemProps> = ({ clickHandler }) => {
    const classes = useStyles();

    const intercomService = useInstance(IntercomService);
    const intercomState = useInstance(IntercomState);
    useSubscription(() => intercomState);

    const unreadIntercomCount = intercomState.state.unreadCount;

    return (
        <div className={classes.chatNavItem}>
            <NavigationItem
                label="Contact Us"
                key="intercom-nav-item"
                onClick={() => {
                    clickHandler(() => {
                        intercomService.displayMessenger();
                    });
                }}
                icon={<DuoCommentsIcon />}
            />
            {unreadIntercomCount > 0 &&
                <div style={{position: 'absolute', right: 26, marginTop: -34, zIndex: 1}}>
                    <ReminderBadge size="medium" count={unreadIntercomCount} />
                </div>
            }
        </div>
    );
};
